<template>
  <v-container>
    <div id="headersTime">
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <div
          id="idTable"
          style="overflow-x: auto;"
        >
          <table
            style="width: 100%; color: black; border-collapse: collapse;"
            class="elevation-1"
            mobile-breakpoint="0"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Vendedor
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Clientes Ativos
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Positivados
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  % Postivação
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Sem Compra
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Núm. Total de Notas
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Ticket Médio
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in dados"
                :key="item.id"
              >
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.vendedor }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.cliente }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.positivados }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.porcentagem }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.semCompra }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.nota }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.ticket }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <router-link
          id="linkDetalhe"
          to="/time/detalhe-time-cobertura"
          class="text-center"
          :style="styleObject"
        >
          <div
            id="linkDetalheAnaliseVendas"
            class="text-center"
          >
            <v-icon
              id="iconLinkAnaliseVendas"
              class="text-center"
            >
              mdi-chevron-double-down
            </v-icon><br>
          </div>
        </router-link>
      </div>
    </div>
  </v-container>
</template>

<script>
  import Time from '../../../../../services/time'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'DashboardTableCoberturaVendedor',
    emits: ['enableBtnPrint'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      selectResumo: [],
      selectMes: [],
      selectAno: [],
      selectSupervisor: [],
      receita: [],
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      supervisor: [],
      segmento: [],
      vendedor: [],
      headers: [
        { text: 'Vendedor', value: 'vendedor', class: 'black--text title' },
        { text: 'Clientes Ativos', value: 'cliente', align: 'right', class: 'black--text title' },
        { text: 'Positivados', value: 'positivados', align: 'right', class: 'black--text title' },
        { text: '% Postivação', value: 'porcentagem', align: 'right', class: 'black--text title' },
        { text: 'Sem Compra', value: 'semCompra', align: 'right', class: 'black--text title' },
        { text: 'Núm. Total de Notas', value: 'nota', align: 'right', class: 'black--text title' },
        { text: 'Ticket Médio', value: 'ticket', align: 'right', class: 'black--text title' },
      ],
      dados: [],
      minWidth: 1380,
      width: window.innerWidth,
      enableTable: false,
    }),

    created () {
      eventEmit.$on('update-time', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-time', this.handleUpdateDados)
    },

    methods: {
      // this.primeiroDia, this.date, this.select, this.supervisor, this.receita, this.segmento, [], [], [], [], this.vendedores
      handleUpdateDados (primeiroDia, dataFinal, select, supervisor, receita, segmento, rede, categoria, promotor, classificacao, vendedor) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.supervisor = supervisor
        this.receita = receita
        this.segmento = segmento
        this.vendedor = vendedor

        this.dados = []
        this.enableTable = false

        localStorage.setItem('supervisorSelect', JSON.stringify(this.supervisor))
        localStorage.setItem('receitaSelect', JSON.stringify(this.receita))
        localStorage.setItem('empresaSelect', this.select)

        this.showTableCoberturaVendedor()
      },

      async showTableCoberturaVendedor () {
        this.loading = true

        await Time.showCoberturaVendedor(this.primeiroDia, this.date, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.segmento, [], [], [], this.vendedor).then(resposta => {
          if (resposta.data.status) {
            this.enableTable = true

            this.dados = resposta.data.dados.map((item) => {
              var listaMelhoresClientes = ({
                vendedor: item.vendedor,
                cliente: item.cliente.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                positivados: item.positivados.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                porcentagem: item.porcentagem.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%',
                semCompra: item.semCompra.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                nota: item.nota ? item.nota : 0,
                ticket: item.ticket.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              })

              return listaMelhoresClientes
            })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.enableTable = false

            this.dados = []

            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          eventEmit.$emit('enable-btn-print', true)

          this.loading = false
        })
      },

      applyBoldClass (item) {
        return item.vendedor === 'Total' ? 'bold-row' : ''
      },

      formatCurrency (value) {
        // Função para formatar um valor numérico para moeda brasileira
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #headersTime {
      font-size: 9px;
      width: 100% !important;
    }

    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 680px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #headersTime {
      font-size: 9px;
      max-width: 100%;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>

<style lang="sass">
  #headersTime
    font-size: 9px

  .tr-min
    display:none

</style>
